import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el sistema?',
    a: 'Al instante. Después del pago recibís un email con el enlace de descarga. En menos de 5 minutos tenés todo en tu celular o computadora.'
  }, {
    q: '¿Funciona si nunca hice trabajo emocional?',
    a: 'Especialmente para vos. Las preguntas te guían paso a paso sin asumir conocimiento previo.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí. $19.990, una sola vez. Sin suscripciones, sin renovaciones automáticas. Pagás una vez y es tuyo para siempre.'
  }];
  return <section className="w-full px-4 py-6 md:py-10 bg-white" data-id="element-46">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-47">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-text-main" data-id="element-48">
          Preguntas frecuentes
        </h2>
        <div className="space-y-2" data-id="element-49">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-50" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-background rounded-lg border border-gray-100 overflow-hidden" data-id="element-51">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 py-3 flex justify-between items-center text-left focus:outline-none" data-id="element-52">
        <span className="font-bold text-text-main text-sm md:text-base pr-3" data-id="element-53">
          {question}
        </span>
        <ChevronDown className={`w-4 h-4 text-primary transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-54" />
      </button>
      <div className="grid transition-all duration-200" style={{
      gridTemplateRows: isOpen ? '1fr' : '0fr'
    }} data-id="element-55">
        <div className="overflow-hidden" data-id="element-56">
          <div className="px-4 pb-3 text-text-muted text-xs md:text-sm leading-snug" data-id="element-57">
            {answer}
          </div>
        </div>
      </div>
    </div>;
}